import { SvgIconProps } from "@mui/material";

import En from "../../assets/icons/En.svg";
import EnUS from "../../assets/icons/En_Us.svg";
import Nl from "../../assets/icons/Nl.svg";
import De from "../../assets/icons/De.svg";
import Fr from "../../assets/icons/Fr.svg";
import Rs from "../../assets/icons/Rs.svg";
import Pt from "../../assets/icons/Pt.svg";
import Es from "../../assets/icons/ES.svg";
import Jp from "../../assets/icons/JP.svg";
import Pl from "../../assets/icons/Pl.svg";
import It from "../../assets/icons/It.svg";

type LocaleIconProps = { name: string } & SvgIconProps;

type LocaleIconTypes = {
  [name: string]: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
};

const iconTypes: LocaleIconTypes = {
  en: En,
  en_US: EnUS,
  nl: Nl,
  sr: Rs,
  de: De,
  fr: Fr,
  pt: Pt,
  es: Es,
  ja: Jp,
  pl: Pl,
  it: It,
};

const LocaleIcon: React.FC<LocaleIconProps> = ({
  name,
  ...props
}: LocaleIconProps) => {
  const Icon = iconTypes[name];
  return <Icon {...props} />;
};

export default LocaleIcon;
